import { buildUrl } from '../../../common/urlBuilder';
import Service from '../../../service';

export const getHotelChain = async (filteredData) => {
  let url = buildUrl('v1/hotelchain-management/hotel-chain');
  if (filteredData) url += `?${filteredData}`;

  return Service.get(url);
};

export const getAllHotel = async (filteredData) => {
  let url = buildUrl('v1/hotel-management/hotel/pagination');
  if (filteredData) url += `?${filteredData}`;

  return Service.get(url);
};

export const findByIdHotel = async (id) => {
  let url = buildUrl(`v1/hotel-management/hotel/${id}`);

  return Service.get(url);
};

export const createHotelDetail = async (data) => {
  let url = buildUrl('v1/hotel-management/hotel');

  return Service.post(url, data);
};

export const updateHotelDetail = async (data, id) => {
  let url = buildUrl(`v1/hotel-management/hotel/${id}`);
  return Service.put(url, data);
};

export const deleteHotel = async (id) => {
  let url = buildUrl(`v1/hotel-management/hotel/${id}`);
  return Service.delete(url);
};

export const createFinancialInformation = async (data) => {
  let url = buildUrl('v1/hotel-management/financial-information');

  return Service.post(url, data);
};

export const updateFinancialInformation = async (data, id) => {
  let url = buildUrl(`v1/hotel-management/financial-information/${id}`);
  return Service.put(url, data);
};

export const createCancellationPolicy = async (data) => {
  let url = buildUrl('v1/hotel-management/policy');

  return Service.post(url, data);
};

export const updateCancellationPolicy = async (data, id) => {
  let url = buildUrl(`v1/hotel-management/policy/${id}`);
  return Service.put(url, data);
};

export const createHotelTeam = async (data) => {
  let url = buildUrl('v1/hotel-management/team');

  return Service.post(url, data);
};

export const updateHotelTeam = async (data, id) => {
  let url = buildUrl(`v1/hotel-management/team/${id}`);
  return Service.put(url, data);
};

export const createHotelMedia = async (data) => {
  let url = buildUrl('v1/hotel-management/media');

  return Service.post(url, data);
};

export const updateHotelMedia = async (data, id) => {
  let url = buildUrl(`v1/hotel-management/media/${id}`);
  return Service.put(url, data);
};

export const createAdditionalHotelDetails = async (data) => {
  let url = buildUrl('v1/hotel-management/hotel-details');

  return Service.post(url, data);
};

export const updateAdditionalHotelDetails = async (data, id) => {
  let url = buildUrl(`v1/hotel-management/hotel-details/${id}`);
  return Service.put(url, data);
};


export const findRoomDetailsById = async (id) => {
  let url = buildUrl(`v1/room-management/room/${id}`);

  return Service.get(url);
};

export const create = async (data) => {
  let url = buildUrl('v1/room-management/room');

  return Service.post(url, data);
};

export const update = async (data, id) => {
  let url = buildUrl(`v1/room-management/room/${id}`);
  return Service.put(url, data);
};

export const upsertRoom = async (data, id) => {
  let url = buildUrl(`v1/room-management/room/upsert`);
  return Service.put(url, data);
};

export const deleteRoom = async (id) => {
  let url = buildUrl(`v1/room-management/room/${id}`);
  return Service.delete(url);
};

export const getAllRoom = async (filteredData) => {
  let url = buildUrl('v1/room-management/room');
  if (filteredData) url += `?${filteredData}`;

  return Service.get(url);
};

export const getAllRoomType = async (filteredData) => {
  let url = buildUrl('v1/hotel-management/room-type');
  if (filteredData) url += `?${filteredData}`;

  return Service.get(url);
};

export const getAllRoomView = async (filteredData) => {
  let url = buildUrl('v1/hotel-management/room-view');
  if (filteredData) url += `?${filteredData}`;

  return Service.get(url);
};

export const getAllBedType = async (filteredData) => {
  let url = buildUrl('v1/hotel-management/bed-type');
  if (filteredData) url += `?${filteredData}`;

  return Service.get(url);
};

export const getAllRatePlan = async (filteredData) => {
  let url = buildUrl('v1/site-management/rate-plan');
  if (filteredData) url += `?${filteredData}`;

  return Service.get(url);
};

export const getAllInclusion = async (filteredData) => {
  let url = buildUrl('v1/inclusion');
  if (filteredData) url += `?${filteredData}`;

  return Service.get(url);
};

// Restaurant Details API functions
export const createRestaurantDetails = async (data) => {
  let url = buildUrl('v1/hotel-management/restaurant-details');

  return Service.post(url, data);
};

export const updateRestaurantDetails = async (data, id) => {
  let url = buildUrl(`v1/hotel-management/restaurant-details/${id}`);
  return Service.put(url, data);
};

export const getRestaurantDetailsByHotelId = async (hotelId) => {
  let url = buildUrl(`v1/hotel-management/restaurant-details/hotel/${hotelId}`);

  return Service.get(url);
};

export const getRestaurantDetailsById = async (id) => {
  let url = buildUrl(`v1/hotel-management/restaurant-details/${id}`);

  return Service.get(url);
};

export const getAllHotelList = async (filteredData) => {
  let url = buildUrl('v1/hotel-management/hotel');
  if (filteredData) url += `?${filteredData}`;

  return Service.get(url);
};
